import { IProtectionPlan } from "./types";

export const protectionPlanInitialState: IProtectionPlan = {
  id: "",
  name: "",
  description: "",
  excess: 0,
  code: "",
};
